import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../auth/UseUser';
import { FaUserAlt } from 'react-icons/fa';
import { ReactComponent as Hamburger } from '../assets/svg/Hamburger.svg';
import { ReactComponent as PuskicaLogoSarena } from '../assets/svg/PuskicaLogoSarena.svg';
import { ReactComponent as Logout } from '../assets/svg/Logout.svg';
import { ReactComponent as Login } from '../assets/svg/Login.svg';
import { getKategorijeVisible } from '../server/server-kategorije-tree';
import { TypeOfEtity } from '../model/enum/typeOfEntity';
import { format } from 'date-fns';
import { PUSKICE_ENABLED } from '../constatnts/FeatureFlags';

function NavBar({ toggleSideBar }: any) {
    const {
        isSignedIn,
        user,
        setUser,
        setIsAdminApp,
        setTipEtiteta,
        setShowSelectedPuskica,
        setSelectedPuskica,
        setSelectedPitanja,
        setNavLista,
        setReturnedList,
    } = useUser();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<any>(null);
    const buttonRef = useRef<any>(null);

    // Zatvaranje menija kada korisnik klikne van njega
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const logout = () => {
        if (window.confirm('Da li ste sigurni da želite da se odjavite?')) {
            localStorage.clear();
            setUser({});
        }
    };

    const handleAdminButton = () => {
        navigate('/admin');
        setIsAdminApp(true);
    };
    const handleKvizoviButton = () => {
        navigate('/user/kviz');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setNavLista([]);
        setIsAdminApp(false);
    };
    const handleHomeButton = () => {
        navigate('/home');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setIsAdminApp(false);
    };
    const handleKategorijeButton = () => {
        navigate('/user/kategorija');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setIsAdminApp(false);
    };
    const handlePuskiceButton = () => {
        navigate('/user/puskice');
        setShowSelectedPuskica(false);
        setNavLista([]);
        setReturnedList([]);
        setIsAdminApp(false);
        loadKategorijeVisible();
    };
    const handleTestoviButton = () => {
        navigate('/user/oblast/54ba3d07-da2b-44b9-a734-a8c835cae69b');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setIsAdminApp(false);
    };
    const handleAutomehanikaButton = () => {
        navigate('/user/oblast/6721c005-fe63-4dd7-ae82-1a31986495ec');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setIsAdminApp(false);
    };
    const handleLoginButton = () => {
        navigate('/login');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setIsAdminApp(false);
    };
    const loadKategorijeVisible = async () => {
        const resp = await getKategorijeVisible();
        if (resp.status === 200) {
            setTipEtiteta(TypeOfEtity.Kategorija);
            console.log('returned list', resp.data);
            setReturnedList(resp.data);
        }
    };
    return (
        <div className="w-full h-[70px] flex justify-between items-center px-8 bg-blueDark  text-white overflow-x-hidden ">
            <div onClick={() => toggleSideBar()} className="w-[35px] h-[35px] rounded-full cursor-pointer opacity-80 hover:opacity-100 flex lg:hidden">
                <Hamburger className="w-[32px] h-[32px]" />
            </div>
            <button className="flex flex-row items-center gap-1" onClick={() => handleHomeButton()} title="Početna stranica">
                <PuskicaLogoSarena width={70} height={70} />
                <ColoredText text="PUŠKICA-KVIZ" />
            </button>
            {user?.isAdmin && (
                <p className="hidden lg:flex text-white hover:text-gold cursor-pointer" onClick={() => handleAdminButton()}>
                    Admin
                </p>
            )}

            <div className="hidden lg:flex items-center  justify-end gap-6">
                <button onClick={() => handleKategorijeButton()}>
                    <p className="text-white font-medium text-[16px] leading-5 hover:text-gold ">Kategorije</p>
                </button>
                <button onClick={() => handleKvizoviButton()}>
                    <p className="text-white font-medium text-[16px] leading-5 hover:text-gold ">Kvizovi</p>
                </button>
                {isSignedIn && PUSKICE_ENABLED && (
                    <button onClick={() => handlePuskiceButton()}>
                        <p className="text-white font-medium text-[16px] leading-5 hover:text-gold ">Puškice</p>
                    </button>
                )}

                <button className="" onClick={() => handleAutomehanikaButton()} title="Testovi znanja iz automehanike">
                    <p className="text-white font-medium text-[16px] leading-5 hover:text-gold">
                        Testovi znanja <br /> iz automehanike
                    </p>
                </button>

                <button className="" onClick={() => handleTestoviButton()} title="Pripremni testovi za upis u srednju školu">
                    <p className="text-white font-medium text-[16px] leading-5 hover:text-gold">
                        Testovi za <br /> srednju školu
                    </p>
                </button>
                {!isSignedIn && (
                    <button onClick={() => handleLoginButton()} title="Prijavite se">
                        <p className="text-white font-medium text-[16px] leading-5 hover:text-gold ">Prijava</p>
                    </button>
                )}
                {isSignedIn && (
                    <button onClick={() => logout()} title="Odjavite se">
                        <p className="text-white font-medium text-[16px] leading-5 hover:text-gold ">Odjava</p>
                    </button>
                )}
                <button ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
                    <div className="min-w-8 max-w-8 h-8 rounded-full bg-[#aaaaaa] flex items-center justify-center" title="Profil">
                        {!!user?.username ? <p className="text-[16px] leading-[20px] font-semibold text-[#000000] ">{user?.username[0]}</p> : <FaUserAlt />}
                    </div>
                </button>
            </div>
            {isOpen && (
                <div ref={menuRef} className="absolute top-[60px] right-[20px] w-[375px] bg-white text-black rounded-[10px] shadow-lg pb-5 z-[11]">
                    <div className=" flex flex-col items-center justify-center gap-1  bg-blueSuperLight h-20 rounded-t-[10px]">
                        <p className="mt-[55px] text-grey-800 font-semibold text-[14px] leading-5">{user?.username ?? 'Neprijavljen korisnik'}</p>
                        <div className="min-w-16 max-w-16 min-h-16 rounded-full bg-[#aaaaaa] flex items-center justify-center border border-white">
                            {!!user?.username ? (
                                <p className="text-[20px] leading-[24px] font-medium text-[#000000] ">{user?.username[0]}</p>
                            ) : (
                                <FaUserAlt size={30} color="#424242" />
                            )}
                        </div>
                    </div>
                    <p className="mt-8 text-[14px] leading-[20px] font-medium text-grey-800 text-center">{user?.email}</p>
                    <div className="flex flex-col px-3">
                        {isSignedIn && (
                            <div className="flex flex-row justify-between mt-5">
                                <p className="text-grey-800 font-semibold text-[14px] leading-5">Vazenje pretplate</p>
                                <p className="text-grey-800 font-medium text-[14px] leading-5">{format(user?.endDate ?? null, 'dd.MMM.yyyy HH:mm')}</p>
                            </div>
                        )}
                        <div className="border-b border-b-grey-A700 mt-5"></div>
                        {isSignedIn ? (
                            <button className="flex flex-row mt-5 items-center gap-2 " onClick={() => logout()}>
                                <Logout />
                                <p className="text-grey-800 font-semibold text-[14px] leading-5 hover:text-grey-900">Odjavite se</p>
                            </button>
                        ) : (
                            <button className="flex flex-row mt-5 items-center gap-2 " onClick={() => handleLoginButton()}>
                                <Login />
                                <p className="text-grey-800 font-semibold text-[14px] leading-5 hover:text-grey-900">Prijavite se</p>
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default NavBar;

const colors = ['#EA4335', '#FBBC05', '#34A853', '#4285F4', '#FF6D00', '#46BD92', '#AB47BC', '#F4B400']; // Boje poput Google/Slack logotipa

export const ColoredText = ({ text = 'PUŠKICA-KVIZ', fontSize = 22 }) => {
    return (
        <span>
            {text.split('').map((char: any, index: number) => (
                <span key={index} style={{ color: colors[index % colors.length], fontWeight: 'bold', fontSize }}>
                    {char}
                </span>
            ))}
        </span>
    );
};
